import { dump } from "../../../utils/dump"

export const ElementEntry = ({ entry }) => {
  return <>{dump(entry)}</>
}
